
import { Component, BaseMixins, $http } from '@/lib';
import Footer from '../../../components/Footer.vue'
import TenantSwitch from './components/tenant-switch.vue'
import appConfig from '@/config';
// import LanguageSwitch from '../../../components/language-switch.vue'

@Component({
  components:{Footer,TenantSwitch}
})
export default class Login extends BaseMixins {
  loginModel={
    userNameOrEmailAddress:'',
    password:'',
    tenancyName: '',
    rememberMe:false
  }
  logoUrl: string = require("../../../images/logo.jpg");
  showChangeTenant:boolean=false
  multiTenancy:boolean = appConfig.multiTenancy;

  async login(){
    (this.$refs.loginform as any).validate(async (valid:boolean)=>{
       if(valid){
          this.$Message.loading({
            content:this.L('Login.LoginPrompt'),
            duration:0
          })
          await this.$store.dispatch({
            type:'app/login',
            data:this.loginModel
          })
          sessionStorage.setItem('rememberMe',this.loginModel.rememberMe?'1':'0');
          location.reload();
       }
    });      
  }
  tenancyName(){
    return window.basic.utils.getTenancyNameCookie();
  }
  rules={
    userNameOrEmailAddress: [
      { required: true, message: this.L('Validate.PleaseInput') + this.L('Login.UserNameOrEmail'), trigger: 'blur' }
    ],
    password: [
      { required: true, message: this.L('Validate.PleaseInput') + this.L('Login.Password'), trigger: 'blur' }
    ]
  }

  mounted() {
    // 绑定enter事件
    this.enterKeyup();
  }

  destroyed() {
    // 销毁enter事件
    this.enterKeyupDestroyed();
  }

  enterKey(event) {
    if (this.showChangeTenant) {
      return;
    }
    const code = event.keyCode
            ? event.keyCode
            : event.which
                    ? event.which
                    : event.charCode;
    if (code == 13) {
      this.login();
    }
  }
  enterKeyupDestroyed() {
    document.removeEventListener("keyup", this.enterKey);
  }
  enterKeyup() {
    document.addEventListener("keyup", this.enterKey);
  }
}
